module.exports = __webpack_public_path__ + "static/img/culture-value.2e30c08d.png";